import React from 'react'
import { getSize, getVariation } from '@toasttab/shared/src/utils/Craft/button'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import { DSButtonProps } from './DSButton.d'

const DSButton = (button: DSButtonProps) => {
  return (
    <Button
      classes={button.classes}
      fontWeight={['font-semibold']}
      fullwidth={button.buttonPadding === 'Full Width'}
      href={button.ctaLink}
      size={getSize(button.buttonPadding)}
      variation={getVariation(button.buttonVariations)}
    >
      {button.ctaLabel}
    </Button>
  )
}

export default DSButton
